module.exports = __webpack_public_path__ + "img/businessInsurance.c27cf68e.jpg";